export const getError = (state) => state.error;
export const getSuccess = (state) => state.success;
export const getIsLoading = (state) => state.isLoading;
export const getDataList = (state) => state.dataList;
export const getTotal = (state) => state.total;
export default {
    getError,
    getIsLoading,
    getSuccess,
    getDataList,
    getTotal,
};
